import { render, staticRenderFns } from "./AdminOutcomeModal.vue?vue&type=template&id=221c8d52&scoped=true&"
import script from "./AdminOutcomeModal.vue?vue&type=script&lang=js&"
export * from "./AdminOutcomeModal.vue?vue&type=script&lang=js&"
import style0 from "./AdminOutcomeModal.vue?vue&type=style&index=0&id=221c8d52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c8d52",
  null
  
)

export default component.exports